var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"breadcrumbList"},[_vm._l((_vm.crumbs),function(crumb,index){return [_c('mi-breadcrumb',{key:index,staticClass:"breadcrumb--item",attrs:{"crumb":crumb}}),(index < _vm.crumbs.length - 1)?_c('mi-breadcrumb-divider',{key:'d'+index,staticClass:"breadcrumb--item"}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }